import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './index.css';
import App from './App';
import MainLayout from './layouts/MainLayout';
import ParkingResults from './pages/airport-parking/Results';
import HotelResults from './pages/hotels/Results';
import HotelDetails from './pages/hotels/Details';
import LoungeResults from './pages/airport-lounges/Results';
import AirportHotelsResults from './pages/airport-hotels/Results';
import ToursResults from './pages/tours/Results';
import ToursDetails from './pages/tours/Details';
import Checkout from './pages/checkout/Page';
import OrderDetails from './pages/order/Details';

const localizedRoutes = (path, element) => [
  { path, element },
  { path: `:locale/${path}`, element },
];

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/",
    element: <MainLayout />,
    children: [
      ...localizedRoutes("airport-parking/results", <ParkingResults />),
      ...localizedRoutes("hotels/results", <HotelResults />),
      ...localizedRoutes("hotels/details", <HotelDetails />),
      ...localizedRoutes("airport-lounges/results", <LoungeResults />),
      ...localizedRoutes("airport-hotels/results", <AirportHotelsResults />),
      ...localizedRoutes("tours/results", <ToursResults />),
      ...localizedRoutes("tours/details", <ToursDetails />),
      ...localizedRoutes("checkout", <Checkout />),
      ...localizedRoutes("order/details", <OrderDetails />),
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);


